import React from 'react'
import Box from '@mui/system/Box'
import Typography from '@mui/material/Typography'
import StatusBar from 'components/reusable/statusBar/AdxStatusBar'
import ChevronRight from '@mui/icons-material/ChevronRight'

const Column2 = ({ status, totalAmount, variant }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'end',
        alignItems: 'center',
        gap: 2,
      }}
    >
      <StatusBar status={status} />
      <Box
        sx={{
          display: 'flex',
          flexDirection: variant === 1 ? 'row' : 'row-reverse',
          alignItems: variant === 1 ? 'flex-end' : 'center',
        }}
      >
        <Typography
          variant="body1"
          color="dark-text.main"
          fontWeight="bold"
          component="span"
          noWrap
        >
          RM
          {` ${parseFloat(totalAmount).toFixed(2)}`}
        </Typography>
        {variant === 1 && <ChevronRight color="light-gray-text" />}
      </Box>
    </Box>
  )
}

export default Column2
